import { panoramaClientFactory, } from '../exports/panorama';
import { getArtifactVersion, getFullArtifactId } from '../utils';
export var createPanoramaClientForEditorIframe = function (Wix, options) {
    var _a, _b, _c;
    var globalConfig = options.globalConfig, platform = options.platform, componentId = options.componentId, sentryConfig = options.sentryConfig, sentryEnvironment = options.sentryEnvironment, Sentry = options.Sentry;
    var factory = panoramaClientFactory({
        baseParams: {
            fullArtifactId: getFullArtifactId(),
            artifactVersion: getArtifactVersion(),
            componentId: componentId,
            platform: platform,
            uuid: (_a = Wix === null || Wix === void 0 ? void 0 : Wix.Utils.getUid()) !== null && _a !== void 0 ? _a : '',
            msid: (_b = Wix === null || Wix === void 0 ? void 0 : Wix.Utils.getInstanceValue('metaSiteId')) !== null && _b !== void 0 ? _b : '',
            appDefId: (_c = Wix === null || Wix === void 0 ? void 0 : Wix.Utils.getInstanceValue('appDefId')) !== null && _c !== void 0 ? _c : '',
        },
        pluginParams: {
            sentry: Sentry,
            sentryDsn: sentryConfig === null || sentryConfig === void 0 ? void 0 : sentryConfig.DSN,
            sentryMain: true,
            sentryEnvironment: sentryEnvironment,
        },
    });
    if (globalConfig) {
        factory.withGlobalConfig(globalConfig);
    }
    return factory.client();
};
export var createPanoramaClientForWorker = function (essentials, options) {
    var componentId = options.componentId, sentryConfig = options.sentryConfig, sentryEnvironment = options.sentryEnvironment;
    return essentials.createPanoramaClient({
        fullArtifactId: getFullArtifactId(),
        artifactVersion: getArtifactVersion(),
        componentId: componentId,
        sentryDsn: sentryConfig === null || sentryConfig === void 0 ? void 0 : sentryConfig.DSN,
        sentryEnvironment: sentryEnvironment,
    });
};
//# sourceMappingURL=createPanoramaClient.js.map